import { IconButton, MenuItem, AppBar as MuiAppBar } from "@mui/material";
import Badge, { badgeClasses } from "@mui/material/Badge";
import { styled } from "@mui/material/styles";
import Button from "@components/Button/Button";

export const AppBarStyled = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: theme.palette.common.white,
  color: theme.palette.text.primary,
  borderBottom: `1px solid ${theme.palette.strokeColor.secondary}`,
  boxShadow: "none",
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

export const NotificationBadgeStyled = styled(Badge)`
  & .${badgeClasses.badge} {
    top: -12px;
    right: -6px;
  }
`;

export const AccountButtonStyled = styled(Button)(({ theme }) => ({
  "& .MuiButton-startIcon > *:nth-of-type(1)": {
    fontSize: "1.5rem", // or any value
  },
  "backgroundColor": theme.palette.background.navigation,
  "borderRadius": "20px",
  "border": "none",
  "padding": "8px 16px",
  "textTransform": "none",
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const HeaderIconButtonStyled = styled(IconButton)(({ theme }) => ({
  "color": theme.palette.text.primary,
  "backgroundColor": theme.palette.background.navigation,
  "borderRadius": "50%",
  "padding": theme.spacing(1),
  "marginRight": theme.spacing(1),
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const MenuItemStyled = styled(MenuItem)(({ theme }) => ({
  "color": theme.palette.text.primary,
  "padding": theme.spacing(1.5),
  "fontWeight": theme.typography.fontWeightMedium,
  "&:hover": {
    backgroundColor: theme.palette.action.selected,
    borderRadius: "4px",
  },
  "&.Mui-selected": {
    backgroundColor: theme.palette.action.selected,
  },
  "& svg": {
    fill: theme.palette.text.primary,
  },
}));
